// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UpdateForm_wrapper__cmCiW","createdBy":"UpdateForm_createdBy__vHUHL"};